import { IconButton } from '@wix/design-system';
import { WidgetClosingTrigger } from '@wix/wix-chatbot-common/bi';
import { MinusSmall } from '@wix/wix-ui-icons-common';
import React, { FC, useCallback } from 'react';

import { widgetSDK } from '../../../sdk/widgetSDK';
import { renderModel } from '../../../util/renderModel';
import { headerActionsDataHooks } from './HeaderActions.dataHooks';

const isWidget = renderModel.isWidget();

export const CloseWidget: FC = () => {
  const onClick = useCallback(
    () => widgetSDK.collapseWidget(WidgetClosingTrigger.CloseButton),
    [],
  );

  if (!isWidget) {
    // we don't need to render the close widget button if we are not in the widget
    return null;
  }

  return (
    <IconButton
      skin="light"
      priority="secondary"
      size="small"
      onClick={onClick}
      dataHook={headerActionsDataHooks.closeWidgetIcon()}
    >
      <MinusSmall />
    </IconButton>
  );
};
